import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { SpotlightFormSchema } from "./spotlight-schema";

const SpotlightDocumentSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  enabled: z.boolean(),
  publishedAt: z.date().nullish(),
  form: SpotlightFormSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const SpotlightDocumentSchema: z.ZodType<SpotlightDocument> =
  SpotlightDocumentSchema_;
export interface SpotlightDocument
  extends z.infer<typeof SpotlightDocumentSchema_> {}
